var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mainContainer fadeIn"},[_c('Header'),_c('div',{staticClass:"bodyBox"},[_c('Sidebar'),_c('MainContent'),_c('ModalsContainer')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }